/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Summary from './Summary';
import useForm from '../../../hooks/useForm';
import { cloneDeep, isDate, isEmpty } from 'lodash';
import { getMonthRange } from '../../../utils/date';
import { getManagementPaymentList } from '../../../apis/tax-portal';
import Filters from '../../Filters';
import { ControlTable } from '../../Table';
import { MANAGEMENT_PAYMENT_STATUS, MANAGEMENT_PAYMENT_TYPE, PAYMENT_TYPE } from '../../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import { transformComma } from '../../../utils/validator/comma';
import { preventEvent } from '../../../utils/element';
import { custodianPreview } from '../../../utils/custodian';

const TaxManagements = () => {
  const [searchMonth, setSearchMonth] = useState(new Date());
  const [filters] = useState([
    {
      title: '상호 또는 사업자번호',
      key: 'search.keyword'
    },
    {
      title: "상태",
      key: "search.status",
      type: "select",
      value: "all",
      options: {
        list: [
          { label: "전체", value: "all" },
          { label: "미납", value: "noPaid" },
          { label: "납부", value: "complate" },
          { label: "납부대기", value: "wait" },
        ]
      }
    },
    {
      title: "청구유형",
      key: "search.billType",
      type: "select",
      value: "all",
      options: {
        list: [
          { label: "전체", value: "all" },
          { label: "정기청구", value: "periodic" },
          { label: "개별청구", value: "single" },
          { label: "청구해지", value: "cancel" }
        ]
      }
    }
  ]);
  const [fields] = useState([
    {
      title: "청구유형", key: "billing.type", onValue: (v, _f, d) => {
        v = d?.billing?.status === "cancel" ? "cancel" : v;
        return <span className={`${v === "cancel" ? "error" : ""}`}>{MANAGEMENT_PAYMENT_TYPE.find(f => f.value === v)?.label}</span>;
      }
    },
    {
      title: "상태", key: "status", onValue: (v) => (
        <span className={`${v === "unPaid"
          ? "error"
          : v === "complate"
            ? "color-main-100"
            : ""}`}
        >
          {MANAGEMENT_PAYMENT_STATUS.find(f => f.value === v)?.label}
        </span>
      )
    },
    {
      title: "사업자등록번호",
      key: "billing.management.bsno",
    },
    {
      title: "상호명", key: "billing.management.txprNm", onValue: (v, _f, d) => {

        return <p
          onClick={(e) => {
            preventEvent(e);
            custodianPreview(d?.billing?.postIdx);
          }
          }
        >{v}</p>;
      }

    },
    { title: "청구일", key: "payDate" },
    { title: "청구금액", key: "price", type: "comma" },
    {
      title: "납부금액", key: "status", onValue: (v, _f, d) => {
        return v === "complate" ? transformComma(d.price) : "";
      }
    },
    {
      title: "미납금액", key: "status",
      onValue: (v, _f, d) => {
        return <>
          <p>{v !== "complate" ? transformComma(d.price) : ""}</p>
          {d.totalUnPaidPrice > 0 && <p className='error'>{`(누적 ${transformComma(d.totalUnPaidPrice)})`}</p>}

        </>;
      }
    },
    { title: "납부방식", key: "type", onValue: (v) => PAYMENT_TYPE.find(f => f.value === v)?.label },
    { title: "청구서", key: "" },
  ]);

  useEffect(() => {
    if (isDate(searchMonth)) {
      setForm({ range: { payDate: getMonthRange(0, true, searchMonth) } });
      submit({ ...form, range: { payDate: getMonthRange(0, true, searchMonth) } });
    }
  }, [searchMonth]);


  useEffect(() => {
    setSubmit(submit);
  }, []);

  const submit = (form) => {
    let params = cloneDeep(form);
    if (!isEmpty(params?.search?.keyword)) {
      params.search.keyword = `%${params?.search?.keyword}%`;
    }
    getManagementPaymentList(params).then(res => {
      const { managementList } = res;
      setList(managementList.rows);
      setTotal(managementList.count);
    }).finally(() => setIsLoading(false));
  };

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    // reSubmit,
  } = useForm({
    range: { payDate: getMonthRange(0, true, searchMonth) },
    limit: 10,
    offset: 0,
  });


  return (
    <>
      <Summary searchMonth={searchMonth} setSearchMonth={setSearchMonth} />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        list={list}
        isLoading={isLoading}
        total={total}
        fields={fields}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        selectedList={selectedList}
        setSelected={setSelectedList}
      />
    </>
  );
};

export default TaxManagements;